import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=7084c7b4&scoped=true&"
import script from "./LinkCard.vue?vue&type=script&lang=ts&"
export * from "./LinkCard.vue?vue&type=script&lang=ts&"
import style0 from "./LinkCard.vue?vue&type=style&index=0&id=7084c7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084c7b4",
  null
  
)

export default component.exports